import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
  Input,
  Table,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  setSelectedCollections,
  swapCollections as swapCollectionsAction,
} from '../../actions/Collections';

import { APIupdateCollectionsOrder } from '../../api/Collections';

import CollectionsListItem from './ListItem';

import { userCan } from '../../helpers/Auth';
import { getParentCollection } from '../../helpers/Collections';
import { addFlashMessage } from '../../helpers/FlashMessages';
import { getSetting } from '../../helpers/Settings';
import withDragAndDropContext from '../../helpers/withDragAndDropContext';

class CollectionsList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      movedMenuItem: null,
    };

    this.moveCollection = this.moveCollection.bind(this);
    this.saveCollections = this.saveCollections.bind(this);
  }

  moveCollection(dragIndex, hoverIndex) {
    const { swapCollections } = this.props;
    swapCollections(dragIndex, hoverIndex);
  }

  saveCollections(dragIndex) {
    const { intl, collections } = this.props;

    const parentCollection = getParentCollection(collections[0]);
    this.setState({ movedMenuItem: dragIndex });
    APIupdateCollectionsOrder(
      parentCollection ? parentCollection.uuid : null,
      collections.map(c => (c.uuid)),
    ).then(() => {
      this.setState({ movedMenuItem: null });
    }).catch(() => {
      this.setState({ movedMenuItem: null });
      addFlashMessage({
        type: 'danger',
        text: intl.formatMessage({ defaultMessage: 'Something went wrong' }),
      });
    });
  }

  isSelectAllChecked() {
    const {
      collections,
      selectedCollections,
    } = this.props;

    return collections.length > 0 && collections.length === selectedCollections.length;
  }

  selectAllFiles() {
    const {
      collections,
      selectCollections,
    } = this.props;
    selectCollections(collections);
  }

  unselectAllFiles() {
    const { selectCollections } = this.props;
    selectCollections([]);
  }

  render() {
    const {
      intl,
      collections,
      selectedCollections,
      reorderingMode,
      className,
      handleMoveSelectedItems,
    } = this.props;
    const { movedMenuItem } = this.state;
    const isSelectAllChecked = this.isSelectAllChecked();

    return (
      <div className="collections-list content-wrapper">
        {collections.length > 0 && (
          <div className="table-wrapper">
            <Table
              className={classnames(
                'collections-list',
                className,
                { reordering: reorderingMode },
              )}
              responsive
            >
              <thead>
                <tr>
                  <th className="selector">
                    <Input
                      type="checkbox"
                      className="input-check check-s form-check-input"
                      checked={isSelectAllChecked}
                      onChange={() => {
                        if (isSelectAllChecked) {
                          this.unselectAllFiles();
                        } else {
                          this.selectAllFiles();
                        }
                      }}
                    />
                  </th>
                  <th>
                    {' '}
                  </th>
                  <th>
                    {intl.formatMessage({ defaultMessage: 'Collection Name' })}
                  </th>
                  <th>
                    {intl.formatMessage({ defaultMessage: 'Owner' })}
                  </th>
                  <th>
                    {getSetting('cs1') ? intl.formatMessage({ defaultMessage: 'Date' }) :
                      intl.formatMessage({ defaultMessage: 'Created' })}
                  </th>
                  <th>
                    {' '}
                  </th>
                </tr>
              </thead>
              <tbody>
                {collections.map(c => (
                  <CollectionsListItem
                    id={c.uuid}
                    index={c.uuid}
                    key={c.uuid}
                    collection={c}
                    isSelected={!!selectedCollections.find(sc => (sc.uuid === c.uuid))}
                    moveCollection={this.moveCollection}
                    saveCollections={this.saveCollections}
                    handleMoveSelectedItems={handleMoveSelectedItems}
                    canDrag={userCan('collection.edit', c)}
                    isMoved={movedMenuItem === c.uuid}
                    {...this.props}
                  />
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectedCollections: state.Collections.selectedCollections,
  collectionsLoading: state.Collections.collectionsLoading,
  reorderingMode: state.Files.reorderingMode,
});

const mapDispatchToProps = dispatch => ({
  selectCollections: (collections) => {
    dispatch(setSelectedCollections(collections));
  },
  swapCollections: (firstItem, secondItem) => {
    dispatch(swapCollectionsAction(firstItem, secondItem));
  },
});

CollectionsList.propTypes = {
  intl: PropTypes.object.isRequired,
  selectCollections: PropTypes.func.isRequired,
  swapCollections: PropTypes.func.isRequired,
  handleMoveSelectedItems: PropTypes.func.isRequired,
  selectedCollections: PropTypes.array.isRequired,
  collectionsLoading: PropTypes.bool.isRequired,
  reorderingMode: PropTypes.bool.isRequired,
  collections: PropTypes.array.isRequired,
  className: PropTypes.string,
};

CollectionsList.defaultProps = {
  className: '',
};

export default withDragAndDropContext(
  injectIntl(connect(mapStateToProps, mapDispatchToProps)(CollectionsList)),
);
